<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_software_category_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="ソフトウェアカテゴリ" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <!-- Coll B -->
              <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <!-- Coll C -->
            </div>

          </div>
          <div class="col-xs-4" style="">
          <div class="row" style="margin-bottom:10px;">
              <button class="btn btn-primary" style="min-width:100px;width: 33%;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
              <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:5px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
              <button v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:5px;" @click="onEdit"  >編集</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
              <button v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete" >抹消</button>
            </div>
          </div>
      </div>
      <confirmation-modal tag="deleteMasterSoftwareCategoryModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_software_category';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_belong_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"master_software_category",
      page_acl: acl.generic
    };
  },
  computed: {
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.category, {}),
          utils.extend(fields.category_name, {}),
        ],
      }
    }
  },
  methods: {
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} );
    },
    onEdit(){
      mdebug("onEdit")
      this.commonOnEdit();
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete(){
      bus.$emit("deleteMasterSoftwareCategoryModal",{
        title: "抹消",
        message: "ソフトウェアカテゴリの抹消をしますがよろしいでしょうか?",
        yes_label: "抹消",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      return this.$router.push({ name: "page_0041_master_software_category", params: {} });
    }
  },
  mounted() {
    this.commonLoadRecord({},(err,result)=>{
      this.commonEditDeleteCmdHandler(this);
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0041_master_software_category_detail.vue?17e94f7f